import { CardHeader, IconButton, Typography } from '@mui/material';
import styled from 'styled-components';

import { ContentCardPadding, ContentCardVariant } from '../types';
import { getPaddingObject } from '../utils';

interface HeaderProps {
  $showDivider: boolean;
  $padding: ContentCardPadding;
  $variant: ContentCardVariant;
}

const StyledCardHeader = styled(CardHeader)<HeaderProps>`
  && {
    padding-bottom: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).top};
    padding-top: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).top};
    padding-left: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).left};
    padding-right: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).right};

    ${({ $showDivider, theme }) =>
      $showDivider && `border-bottom: 1px solid ${theme.palette.divider};`}
  }
`;

const Title = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.backdrop.contrastText};
  }
`;

const BackIconButton = styled(IconButton)`
  && {
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Caption = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { StyledCardHeader, Title, Caption, TitleContainer, BackIconButton };
